import { Accordion } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons';
import PropTypes from 'prop-types';
import WebForm from './WebForm';

const webFormShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
});

const WebForms = ({ forms, reloadCallback }) => {
  const webForms = Object.keys(forms ?? {}).map((key) => forms[key]);

  if (webForms.length === 0) {
    return null;
  }

  return (
    <Accordion
      multiple
      variant="separated"
      chevronPosition="left"
      chevron={<IconChevronRight size="1rem" />}
      styles={{
        chevron: {
          '&[data-rotate]': {
            transform: 'rotate(90deg)',
          },
        },
      }}
    >
      {webForms.map((form) => (
        <WebForm key={form.id} form={form} reloadCallback={reloadCallback} />
      ))}
    </Accordion>
  );
};

WebForms.propTypes = {
  forms: PropTypes.oneOfType([PropTypes.arrayOf(webFormShape), PropTypes.objectOf(webFormShape)]).isRequired,
  reloadCallback: PropTypes.func.isRequired,
};

export default WebForms;
